/**
 * `@standandforce/api-contract` の Organization Password Policy を FE 向けに再エクスポート。
 *
 * Contract の SSOT はパッケージの `password-policy.api-contract`。
 *
 * 適用日時（`enforceFrom`）は入出力で形式が異なる。送信は組織タイムゾーンの壁時計時刻
 * （`LocalDateTimeSchema` = `YYYY-MM-DDTHH:mm`）、受信は組織タイムゾーンのオフセット付き
 * ISO8601。変換は `@/utils/date` の `toLocalDateTime` / `parseLocalDateTime` に集約する。
 */
import type { PasswordPolicyRecommendedSchema, PasswordPolicyValueSchema, UpsertOrganizationPasswordPolicyInputSchema } from '@standandforce/api-contract';
import type { z } from 'zod';
export { passwordPolicyContract } from '@standandforce/api-contract';
export type { ListPasswordPolicyVersionsOutput, PasswordPolicySettings, PasswordPolicyVersion, PasswordPolicyVersionStatus, PasswordPolicyView } from '@standandforce/api-contract';
export type PasswordPolicyValue = z.infer<typeof PasswordPolicyValueSchema>;
export type PasswordPolicyRecommended = z.infer<typeof PasswordPolicyRecommendedSchema>;
export type UpsertOrganizationPasswordPolicyInput = z.infer<typeof UpsertOrganizationPasswordPolicyInputSchema>;

/** 入力欄の範囲。contract の `minLength` の min / max と一致させる。 */
export const PASSWORD_POLICY_MIN_LENGTH_RANGE = {
  min: 8,
  max: 128
} as const;

/** 推奨水準を下回っているか（推奨が true の項目のみ判定）。 */
export function isBelowRecommended(value: PasswordPolicyValue, recommended: PasswordPolicyRecommended): boolean {
  return value.minLength < recommended.minLength || recommended.requireUppercase && !value.requireUppercase || recommended.requireLowercase && !value.requireLowercase || recommended.requireNumber && !value.requireNumber || recommended.requireSymbol && !value.requireSymbol || recommended.leakedPasswordCheckEnabled && !value.leakedPasswordCheckEnabled;
}